import { fetchSkillAgentMoodboardAssetBlobUrl } from "../../api/Skills/skillAgentMoodboardsApi";
import { getOfflineAssetBlobUrl } from "./moodboardOfflineStore";

/** Cache de blob: URLs por assetId. No se revocan al desmontar thumbs (evita parpadeo al cambiar de mesa). */
const cache = new Map();

export function peekMoodboardAssetBlobUrl(assetId) {
  const id = Number(assetId);
  if (!Number.isFinite(id)) return "";
  return cache.get(id)?.url || "";
}

/** Si alguien revocó la URL por error, fuerza re-fetch. */
export function invalidateMoodboardAssetBlob(assetId) {
  const id = Number(assetId);
  if (!Number.isFinite(id)) return;
  const hit = cache.get(id);
  if (hit?.url && String(hit.url).startsWith("blob:")) {
    try {
      URL.revokeObjectURL(hit.url);
    } catch {
      /* ignore */
    }
  }
  cache.delete(id);
}

async function fetchWithOfflineFallback(raw, assetId) {
  const tryOffline = async () => {
    try {
      return (await getOfflineAssetBlobUrl(assetId)) || "";
    } catch {
      return "";
    }
  };
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    const offlineUrl = await tryOffline();
    if (offlineUrl) return offlineUrl;
  }
  try {
    return await raw(assetId);
  } catch (err) {
    const offlineUrl = await tryOffline();
    if (offlineUrl) return offlineUrl;
    throw err;
  }
}

export function createMoodboardAssetBlobFetcher(fetchRaw) {
  const raw =
    typeof fetchRaw === "function"
      ? fetchRaw
      : fetchSkillAgentMoodboardAssetBlobUrl;
  return async (assetId) => {
    const id = Number(assetId);
    if (!Number.isFinite(id)) throw new Error("assetId inválido");
    const hit = cache.get(id);
    if (hit?.url) return hit.url;
    if (hit?.promise) return hit.promise;
    const promise = Promise.resolve()
      .then(() => fetchWithOfflineFallback(raw, id))
      .then((url) => {
        const s = typeof url === "string" ? url : "";
        if (!s) {
          cache.delete(id);
          throw new Error("blob vacío");
        }
        cache.set(id, { url: s });
        return s;
      })
      .catch((err) => {
        cache.delete(id);
        throw err;
      });
    cache.set(id, { promise });
    return promise;
  };
}

export function clearMoodboardAssetBlobCache() {
  for (const v of cache.values()) {
    if (v?.url && String(v.url).startsWith("blob:")) {
      try {
        URL.revokeObjectURL(v.url);
      } catch {
        /* ignore */
      }
    }
  }
  cache.clear();
}
